export const ALL_SPACES: string = 'ALL_SPACES'
export const SINGLE_SPACES: string = 'SINGLE_SPACES'
